import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux'

import MediaQuery from 'react-responsive'
import CartView from '../containers/cart/CartView'

import {Power3, TweenLite} from "gsap";
import ReactDOM from 'react-dom'
import {TransitionGroup} from 'react-transition-group'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faShoppingCart} from "@fortawesome/pro-light-svg-icons/faShoppingCart";

class HeaderCartView extends Component {

    static propTypes = {}

    componentWillEnter(callback) {

        const dom = ReactDOM.findDOMNode(this)
        callback();
        TweenLite.fromTo(dom, 0.5, {y: -dom.offsetHeight}, {
            ease: Power3.easeInOut, y: 0, onComplete: () => {

            }
        })

    }

    componentWillLeave(callback) {

        const dom = ReactDOM.findDOMNode(this)

        TweenLite.to(dom, 0.5, {
            ease: Power3.easeOut, y: -dom.offsetHeight, onComplete: () => {
                callback()
            }
        })

    }

    render() {

        return (
            <div className="header-wrapper__cart-view"><CartView/></div>
        )

    }
}

class AppHeader extends Component {

    static propTypes = {
        columnWidth: PropTypes.string,
        indentLeft: PropTypes.bool,
        isSticky: PropTypes.bool,
        clientData: PropTypes.any
    }

    constructor(props) {
        super(props)
        this.state = {
            cartDisplayShown: false
        }
    }

    handleCartTriggerClick = (e) => {

        this.setState({
                cartDisplayShown: !this.state.cartDisplayShown
            }
        )

    }


    render() {

        return (
            <div className="header-wrapper">

                <div className="header">

                    <div className="logo">
                        <a href="http://mittwald.de">
                            <img role="presentation" src="images/mw_logo_white.svg"/>
                            <div className="logo__claim">Hosting neu gedacht</div>
                        </a>
                    </div>

                    {this.props.clientData ?
                        <div className={"header-wrapper__clientdata"}>
                            Angemeldet als {this.props.clientData.firstName + " " + this.props.clientData.lastName}
                        </div> : null}

                    <MediaQuery maxWidth={1023}>
                        <div onClick={this.handleCartTriggerClick} className={"header-cart-trigger-wrapper" + (this.state.cartDisplayShown ? ' header-cart-trigger-wrapper--triggered' : '')}>
                            <FontAwesomeIcon icon={faShoppingCart}/>
                        </div>
                    </MediaQuery>

                </div>
                <MediaQuery maxWidth={1023}>
                    <TransitionGroup component={(props) => {
                        const childrenArray = React.Children.toArray(props.children);
                        return childrenArray[0] || null;
                    }}>
                        {this.state.cartDisplayShown ? <HeaderCartView key="header-cart-view"/> : null}
                    </TransitionGroup>
                </MediaQuery>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {

    return {
        supportBoxVisible: state.ui.supportBoxVisible
    }

}

export default connect(mapStateToProps, null)(AppHeader)



/** WEBPACK FOOTER **
 ** ./src/containers/AppHeader.js
 **/